<div class="statusbar-spacer"></div>
<button matIconButton type="button" class="close" mat-dialog-close><mat-icon>close</mat-icon></button>
<h4 mat-dialog-title>{{ 'legendTxt.title' | translate }}</h4>
   <div class="legend-header flex-container container-space-between column">
        <div class="list-sub-header" [innerHTML]="activeLayerLabel"></div>
    </div>
<mat-dialog-content class="tmv-dialog mat-typography">
 <!-- legend-body legend-wrapper -->
    <div class="column " [@.disabled]="true">
        <ng-template #legendDialogContainer></ng-template>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="right" class="">
    <div class="button-container">
        <button mat-button mat-dialog-close class="close-tip">{{'general.close'|translate}}</button>
    </div>
</mat-dialog-actions>